module.exports = __webpack_public_path__ + "img/starfighter-twin-ion-engine.ecab8363.svg";